import React from 'react';
import { motion } from 'framer-motion';
import { FiCode } from 'react-icons/fi';
import SectionHeader from './SectionHeader';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const TechStackSection = ({ content }) => (
  <section id="stack" className="section section-light">
    <div className="container section-stack">
      <SectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.intro}
      />

      <div className="stack-grid">
        {content.groups.map((group, index) => (
          <motion.article
            key={group.title}
            className="stack-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.5, delay: index * 0.08 }}
          >
            <div className="stack-card-header">
              <FiCode />
              <h3>{group.title}</h3>
            </div>
            <div className="tag-list">
              {group.items.map((item) => (
                <span key={item} className="tag subtle">
                  {item}
                </span>
              ))}
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default TechStackSection;
